module.exports = __webpack_public_path__ + "fonts/ConfigCondensed-SemiBold.469eb84b.otf";